// src/utils/auth.js
// Tiny accessor for the persisted auth payload so any component can gate UI on
// the current user's permissions without prop-drilling. The role/permissions
// only change on (re)login, so reading from localStorage at render is fine.

export const AUTH_KEY = 'gp_admin_auth';

export function getAuth() {
  try {
    return JSON.parse(localStorage.getItem(AUTH_KEY) || 'null');
  } catch {
    return null;
  }
}

export function getCurrentUser() {
  return getAuth()?.user || null;
}
